import { getCurrentUserId } from '../utils';
import { withCurrentParams } from 'actions/utils';
import { ENDPOINT_DELETE } from 'store/eventConstants';
import { BROADCAST_DELETE_STREAM_ENDPOINT } from 'actions/Types';

/**
 * Delete a stream endpoint
 *
 * @param endpointId
 */
export default endpointId => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const { user } = getState();
      const action = {
        type: BROADCAST_DELETE_STREAM_ENDPOINT,
        request: async apiClient => {
          const response = await apiClient.broadcast.deleteStreamEndpoint(
            teamId,
            eventId,
            broadcastId,
            endpointId
          );
          // notify other directors
          socket.emit(ENDPOINT_DELETE, {
            broadcastId,
            notifyingDirector: getCurrentUserId(user)
          });
          return response;
        }
      };

      dispatch(action);
    }
  );
};
